module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN212_1757898433.5561b227.png";